import React, { useState, useEffect } from 'react';
import SelecionarCategoriaProduto from '../Utils/SelecionarCategoriaProduto';
import SelecionarMarca from '../Utils/SelecionarMarca';
import ImageCropper from '../Utils/ImageCropper';
import { Form, Button, Card, Alert, Col} from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useProvider, Toast } from '../../context/MenuProvider';

const MarcaForm = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [marca, setMarca] = useState(null);
    const [fileFoto, setFileFoto] = useState(null);
    const [formErrors, setFormErrors] = useState([]);
    const {
      crud,
      setLinks, setBtns
    } = useProvider();
    const { patch, post, get, del, loading } = crud || {};
    const formData = new FormData();
    

    const handleDelete = () => {
      Swal.fire({
        title: "Tem certeza em excluir?",
        text: "Esta ação é definitiva, não poderá ser revertida.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try{
            const response = await del(`/gvendas/marcas/${id}/`);
            navigate(-1);
            Toast.fire({
                icon: "success",
                title: 'Marca/Fornecedor excluído com sucesso'
            });
          }catch(err){
            Toast.fire({
                icon: "error",
                title: 'Marca/Fornecedor não pode ser excluído no momento'
            });
          }
        }
      });
    }

    // Configuração inicial dos botões e links
    useEffect(() => {
        setLinks([]);
        setBtns([
            ...(id ? [{ icon: 'bi-trash', onClick: handleDelete }] : []),
            { icon: 'bi-check-lg', onClick: handleSubmit }
        ]);

        return () => {
            setLinks([]);
            setBtns([]);
        };
    }, [setBtns, setLinks, marca, fileFoto]); // Removidas dependências desnecessárias

    // Carrega o marcas ao editar
    useEffect(() => {
      if (!!id){
        carregarMarca();
      }
    }, [id]);
    
  

    const carregarMarca = async () => {
        try {

            const response = await get(`/gvendas/marcas/${id}/`);
            if (response && response.length) {
                setMarca(response[0]);
            }
        } catch (err) {
            validarErrosApi(err);
        }
    };

    const validarErrosApi = (err) => {
        const errorMessage = typeof err.response?.data === 'string' 
            ? 'Erro desconhecido ao salvar marca/fornecedor.' 
            : err.response?.data?.detail;

        setFormErrors(prevErrors => ({
            ...prevErrors,
            apiError: errorMessage,
            nome_da_marca: err.response?.data?.nome_da_marca,
            descricao: err.response?.data?.descricao,
            porcentagem_desconto_na_compra: err.response?.data?.porcentagem_desconto_na_compra,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        const errors = {};
        if (marca?.nome === '') errors.nome = 'Por favor, informe o nome do seu negócio.';
        
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        setFormErrors({});

        if(fileFoto) formData.append('logomarca', fileFoto);
        formData.append('nome_da_marca', marca?.nome_da_marca);
        formData.append('descricao', marca?.descricao||``);
        formData.append('porcentagem_desconto_na_compra', marca?.porcentagem_desconto_na_compra||50);
        
        const apiRequest = id ? patch : post;
        try {
            const response = await apiRequest(formData, `/gvendas/marcas/${id?id+'/':''}`, 'multipart/form-data');
            if (response) {
                Toast.fire({
                    icon: "success",
                    title: `Salvo com sucesso`
                });
                navigate(-1);
            }
        } catch (err) {
            validarErrosApi(err);
        }
    };
    

    return (
        <div className="">
              <Card>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
                        <ImageCropper label="Logomarca" foto={marca?.logomarca} setFoto={setFileFoto}/>
                        
                        <Form.Group controlId="formNome">
                            <Form.Label>Nome da marca/fornecedor *</Form.Label>
                            <Form.Control 
                                type="text" 
                                value={marca?.nome_da_marca || ''} 
                                onChange={(e) => 
                                    setMarca((prevMarca) => ({
                                        ...prevMarca,
                                        nome_da_marca: e.target.value
                                    }))
                                }
                            />
                            {formErrors.nome_da_marca && <Alert variant="danger">{formErrors.nome_da_marca}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formPorfentagem">
                            <Form.Label>% de desconto na sua compra para revender*</Form.Label>
                            <Form.Control 
                                type="number" 
                                value={marca?.porcentagem_desconto_na_compra || ''} 
                                onChange={(e) => 
                                    setMarca((prevMarca) => ({
                                        ...prevMarca,
                                        porcentagem_desconto_na_compra: e.target.value
                                    }))
                                }
                            />
                            {formErrors.porcentagem_desconto_na_compra && <Alert variant="danger">{formErrors.porcentagem_desconto_na_compra}</Alert>}
                        </Form.Group>
                        <Form.Group controlId="formDescricao">
                            <Form.Label>Sobre a marca/fornecedor</Form.Label>
                            <Form.Control 
                                as="textarea" 
                                rows={4}
                                value={marca?.descricao || ''} 
                                onChange={(e) => 
                                    setMarca((prevMarca) => ({
                                        ...prevMarca,
                                        descricao: e.target.value
                                    }))
                                }
                            />
                            {formErrors.descricao && <Alert variant="danger">{formErrors.descricao}</Alert>}
                        </Form.Group>
                        <Button variant="dark" type="submit" className="mt-4 w-100" disabled={loading}>
                            {loading ? marca ? "Salvando..." : 'Carregando...' : 'Salvar alterações'}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
};


export default MarcaForm;